import { useQuery } from '@tanstack/react-query';
import { api } from './client';

/**
 * Capacites (options commerciales) actives, fixees au deploiement.
 * Le front adapte navigation et ecrans en consequence ; l'API reste la source
 * de verite (endpoints gardes, alertes filtrees).
 */
export interface Capabilities {
  effectif: boolean;
  tcFin: boolean;
}

const DEFAULT: Capabilities = { effectif: false, tcFin: false };

export function useCapabilities(): Capabilities {
  const { data } = useQuery({
    queryKey: ['capabilities'],
    queryFn: () => api.get<Capabilities>('/capabilities'),
    // Les options ne changent pas en cours de session.
    staleTime: Infinity,
  });
  return data ?? DEFAULT;
}
